import axios from "axios";

const intClient = axios.create({
  baseURL: process.env.VUE_APP_INT_CLIENT,
  timeout: 60000,
});

export default intClient;
